import isPlainObject from 'lodash.isplainobject'
import intersectionBy from 'lodash.intersectionby'

import { capitalize } from './'

const specialParamList = ['splits', 'faders', 'buttons', 'pedals']

export function isUserPreset(preset) {
	return preset.includes('user')
}

function formatParamSendName(name) {
	return specialParamList.includes(name) ? name.substring(0, name.length-1): name;
}

export function getPresetFromID(presets, presetID){
  const [category, index] = presetID.split('-')

  return presets[category][~~index]
}

export function reduceParamObject(param, index = null) {
	return Object.keys(param).reduce((messageArr, key) => {
		messageArr.push(param[key].toString())
		return messageArr
	}, index!=null ? [index] : []).toString()
}

export function reduceParamArray(param, index) {
  return reduceParamObject(param[index], index)
}

export function buildMessage(difference, preset) {
  const diffKey = Object.keys(difference).toString(),
        diffValue = difference[diffKey]
  let messagePayload = ''

  if(isPlainObject(diffValue)) {
    // nested
    if(diffKey === 'gapCaps' || diffKey === 'playParams'){
      messagePayload = Object.keys(preset[diffKey]).reduce(
        (arr, key) => {
          arr.push(preset[diffKey][key]);
          return arr
        }, []).toString()

      return [formatParamSendName(diffKey), messagePayload]
    } else {
      const index = Object.keys(difference[diffKey])
      messagePayload = Object.keys(preset[diffKey][~~index]).reduce(
        (arr, key) => {
					arr.push(preset[diffKey][~~index][key]);

          return arr
        }, [])

      return [formatParamSendName(diffKey), index.concat(messagePayload).toString()]
    }
  } else {
    // single param
    messagePayload = difference[diffKey]
    return [formatParamSendName(diffKey), messagePayload.toString()]
  }
}

export function getOriginPreset(state) {
  const selectdPresetKey = state.editor.selectedPreset, // 'user-0'
        category = selectdPresetKey.split('-')[0], // 'user'
        index = selectdPresetKey.split('-')[1] // 0

  return state.presets[category][index]
}

export function buildPresetMenu(presets) {
  return Object.keys(presets).reduce(
    (menuItems, category) => {
      if(presets[category].length){
        menuItems.push({
          title: capitalize(category),
          id: category,
          options: buildPresetMenuOptions(category, presets[category])
        })
      }
      return menuItems
    }, [])
}

function buildPresetMenuOptions(category, presets) {
  return presets.map(
    (preset, index) => {
      return {
        value: `${category}-${index}`,
        label: (category === 'device') ? 'on-device: ' + preset.name : category + ': ' + preset.name
      }
    }
  )
}

export function getNextPreset(name, presets) {
	const deleteIndex = presets.user.findIndex(element => element.name === name)

	let newPresetID, newSelectPresetID
	// load next preset
	if(presets.user.length > 1) { // if there are at least 2 preset left
		if(deleteIndex === 0) { // delete first preset
			newPresetID = `user-1`
			newSelectPresetID = `user-0`
		} else if(deleteIndex === presets.user.length - 1) { // delete last preset
			newSelectPresetID = newPresetID = `user-${deleteIndex - 1}`
		} else { // delete middle presets
			newPresetID = `user-${deleteIndex + 1}`
			newSelectPresetID = `user-${deleteIndex}`
		}
	} else if(presets.device.length) {
		newSelectPresetID = newPresetID = 'device-0'
	} else if(presets.factory.length) {
		newSelectPresetID = newPresetID = 'factory-0'
	}

	return {
		nextSelectPresetID: newSelectPresetID,
		nextPreset: getPresetFromID(presets, newPresetID)

	}
}

export function deviceVersions(data) {
  const [blMaj,blMin,blPatch, fwMaj,fwMin,fwPatch] = data.values

  return {firmware: [fwMaj,fwMin,fwPatch].join('.'), bootloader: [blMaj,blMin,blPatch].join('.')}
}

export function getDuplicates(storedPresets, importedPresets) {
	return intersectionBy(storedPresets, importedPresets, 'name').reduce((presets, preset, index) => {
		presets[index] = preset.name

		return presets
	}, {});
}

export function exportLocalStorage() {
	const presets = JSON.parse(localStorage.getItem('malletstation_presets.user')),
				a = document.createElement('a')

	a.setAttribute('href', 'data:text/json;charset=utf8,' + encodeURIComponent(JSON.stringify(presets, null, 2)));
	a.setAttribute('download', 'malletStation-user-presets.json');
	a.click()
}
